export default class ProductModel {
  ProductId: number | null;
  SubCategoryId: number | null;
  CategoryId: number | null;
  VendorId: number | null;
  ProductName: string;
  Slug: string;
  Price: number | string;
  OldPrice: number | string;
  Rating: number | string;
  RatingWidth: string;
  BadgeLabel: string;
  BadgeClass: string;
  BrandName: string;
  ProductHomePageSectionId: number | null;
  SectionName?: string;
  HomepageSectionOrder: number;
  IsFreeDelivery: boolean;
  IsPromoBanner: boolean;
  PromoBannerTitle: string;
  PromoBannerDisplayOrder: number;
  IsActive: boolean;
  DisplayOrder: number;
  CategoryName?: string;
  SubCategoryName?: string;
  VendorName?: string;
  Images?: Array<Record<string, unknown>>;
  Features?: Array<Record<string, unknown>>;
  DetailTabs?: Array<Record<string, unknown>>;

  constructor() {
    this.ProductId = null;
    this.SubCategoryId = null;
    this.CategoryId = null;
    this.VendorId = null;
    this.ProductName = '';
    this.Slug = '';
    this.Price = '';
    this.OldPrice = '';
    this.Rating = '';
    this.RatingWidth = '';
    this.BadgeLabel = '';
    this.BadgeClass = '';
    this.BrandName = '';
    this.ProductHomePageSectionId = null;
    this.HomepageSectionOrder = 0;
    this.IsFreeDelivery = false;
    this.IsPromoBanner = false;
    this.PromoBannerTitle = '';
    this.PromoBannerDisplayOrder = 0;
    this.IsActive = true;
    this.DisplayOrder = 0;
    this.Images = [];
    this.Features = [];
    this.DetailTabs = [];
  }
}
